import styled from "@emotion/styled";
import { Box } from "@otrium/core";
import { ColorCheck } from "src/icons/ColorCheck";

const StyledColorContainer = styled.li`
  padding-bottom: ${({ theme }) => theme.space.space16};
  display: flex;
  align-items: center;
`;

const StyledColorBox = styled(Box)<{
  backgroundColor?: string;
  background?: string;
}>`
  ${({ backgroundColor }) =>
    backgroundColor && `background-color: ${backgroundColor};`}

  ${({ backgroundColor, theme }) =>
    backgroundColor &&
    backgroundColor === theme.colors.tone.white &&
    "border: 1px solid rgb(153, 153, 153);"}
  
  ${({ background }) =>
    background &&
    `
      background: url(${background});
      background-position: center;
      background-size: contain;
    `}

  margin: ${({ theme }) =>
    `${theme.space.space0} ${theme.space.space8} ${theme.space.space0} ${theme.space.space0}`};
  border-radius: 20px;
  height: 40px;
  width: 40px;
`;

const Check = styled(ColorCheck)`
  position: absolute;
  left: 12px;
`;

export { StyledColorContainer, StyledColorBox, Check };
